import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../redux/store";
import { getBalanceByCategory } from "../../redux/features/timeoff";
import { IGetTimeOffBalance } from "../../types";

const TimeoffBalanceFilter: React.FC = () => {
    const dispatch = useAppDispatch();

    // Fetch categories from state
    const categories = useSelector((state: RootState) => state.common.assignedTimeoffCategories);
    const timeOffBalanceByCategory = useSelector((state: RootState) => state.timeoff.timeOffBalanceByCategory);
    const user = useSelector((state: RootState) => state.user.user);
    // Local state for dropdown selection
    const [selectedCategory, setSelectedCategory] = useState<string>("");

    const handleCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const categoryCode = event.target.value;
        setSelectedCategory(categoryCode);
        const body: IGetTimeOffBalance = {
            category_code: categoryCode,
            employee_id: user.id!.toString(),
        };
        dispatch(getBalanceByCategory(body));
    };

    return (
        <div className="w-full max-w-md mx-auto p-4 bg-white rounded-lg">
            <label htmlFor="timeoff-category" className="block text-sm font-medium text-gray-700">
                Select Category
            </label>
            <select
                id="timeoff-category"
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="mt-2 w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                <option value="" disabled>
                    Select a category
                </option>
                {categories.map((category) => (
                    <option key={category.category_code} value={category.category_code}>
                        {category.category_name}
                    </option>
                ))}
            </select>

            {/* <div className="mt-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded-md">
                <p>
                    <span className="text-lg font-semibold text-gray-800">Time-Off Balance:</span> <span>{timeOffBalanceByCategory?.max || "N/A"}</span>
                </p>
            </div> */}
        </div>
    );
};

export default TimeoffBalanceFilter;
